import { CompetitionGroup } from '@plvs/graphql/generated'

export const canViewManagePage = ({
  isCoachAtOrg,
  isPlayerAtOrg,
  competitionGroup,
}: {
  isCoachAtOrg: boolean
  isPlayerAtOrg: boolean
  competitionGroup?: CompetitionGroup | null
}): boolean => {
  // coaches can always view the manage page
  if (isCoachAtOrg) {
    return true
  }

  // any college players may also view the manage page
  if (isPlayerAtOrg && competitionGroup === CompetitionGroup.College) {
    return true
  }

  return false
}
